export default __webpack_public_path__ + "static/media/s4_title-summer.bb20cabe.png";